module.exports = __webpack_public_path__ + "static/media/rgs_clinic_orbbec.82f196ea.png";